// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.error404{\n    width: 100%;\n}", "",{"version":3,"sources":["webpack://src/css/error.css"],"names":[],"mappings":";AACA;IACI,WAAW;AACf","sourcesContent":["\n.error404{\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
